import * as i0 from '@angular/core';
import { Component, Input, HostBinding, Directive, HostListener, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { __awaiter } from 'tslib';
import * as i1 from 'se-fe-position';
import { SeFePositionService } from 'se-fe-position';

class SeFePopoverComponent {
    constructor(elementRef, seFePositionService) {
        this.elementRef = elementRef;
        this.seFePositionService = seFePositionService;
        this._visible = false;
        this.position = 'top'; // for SeFePosition
        this.spacing = 25; // for seFePositon arrow spacing
        this._id = `se-fe-popover-${Date.now()}-${SeFePopoverComponent.counter++}`;
        this.fixedPosition = false;
        this.id = this._id;
        this.role = 'region';
        this.closePopover = (event) => {
            const path = event.composedPath();
            if (path.includes(this.element) || path.includes(this.trigger.instance.element))
                return;
            if (this.trigger)
                this.trigger.toggle();
        };
        // noop
    }
    set seFeDataName(name) {
        this.name = name;
    }
    get visible() {
        return this._visible;
    }
    set visible(value) {
        this._visible = value;
        this.visible ?
            document.addEventListener('keyup', this.closePopover) :
            document.removeEventListener('keyup', this.closePopover);
        this.updateTabindexes();
    }
    get visibleClass() { return this.visible; }
    get hidden() { return !this.visible; }
    get desc() {
        return this.trigger.instance.id;
    }
    get element() {
        return this.elementRef.nativeElement;
    }
    show() {
        return __awaiter(this, void 0, void 0, function* () {
            this.visible = true;
        });
    }
    hide() {
        return __awaiter(this, void 0, void 0, function* () {
            this.visible = false;
        });
    }
    ngOnInit() {
        this.updateTabindexes();
        this.seFePositionService.addContent(this);
    }
    ngOnDestroy() {
        this.seFePositionService.removeContent(this);
    }
    get trigger() {
        return this.seFePositionService.triggers.find(t => t.instance.name === this.name);
    }
    updateTabindexes() {
        const selectors = 'a, area, input, select, textarea, button, [tabindex], [contentEditable=true]';
        const elements = this.element.querySelectorAll(selectors);
        let tabindex = this.visible ? '0' : '-1';
        elements.forEach(element => {
            element.setAttribute('tabindex', `${tabindex}`);
        });
    }
}
SeFePopoverComponent.counter = 1;
SeFePopoverComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFePopoverComponent, deps: [{ token: i0.ElementRef }, { token: i1.SeFePositionService }], target: i0.ɵɵFactoryTarget.Component });
SeFePopoverComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFePopoverComponent, selector: "se-fe-popover", inputs: { name: ["seFePopoverName", "name"], seFeDataName: "seFeDataName", fixedPosition: ["seFeDataFixedPosition", "fixedPosition"], visible: "visible" }, host: { properties: { "class.se-fe-popover--visible": "this.visibleClass", "attr.aria-hidden": "this.hidden", "attr.id": "this.id", "attr.role": "this.role", "attr.aria-labelledy": "this.desc" } }, ngImport: i0, template: "<span class=\"se-fe-popover__arrow\"></span>\n<ng-content class=\"se-fe-popover__content\"></ng-content>\n", styles: [":host.se-fe-position--bottom .se-fe-popover__arrow,:host.se-fe-position--top .se-fe-popover__arrow{position:absolute;height:20px;width:20px;transform-origin:0% 0%;transform:rotate(45deg);z-index:200;background:#e6f8ff}:host{background:#e6f8ff;border:1px solid #00668f;border-radius:3px;color:#23282b;font-size:1rem;font-weight:400;max-width:300px;min-width:170px;overflow:unset;padding:12px;position:absolute;display:block;text-align:left;text-overflow:unset;text-transform:initial;white-space:normal;z-index:50;opacity:0;pointer-events:none}:host.se-fe-popover--visible{opacity:1;pointer-events:all}:host.se-fe-popover--visible.se-fe-position--hidden{opacity:0;pointer-events:none}:host.se-fe-position--top .se-fe-popover__arrow{border-bottom:1px solid #00668f;border-right:1px solid #00668f;bottom:-7px}:host.se-fe-position--bottom .se-fe-popover__arrow{border-top:1px solid #00668f;border-left:1px solid #00668f;top:-16px}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFePopoverComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-popover',
                    templateUrl: './se-fe-popover.component.html',
                    styleUrls: ['./se-fe-popover.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.SeFePositionService }]; }, propDecorators: { name: [{
                type: Input,
                args: ['seFePopoverName']
            }], seFeDataName: [{
                type: Input,
                args: ['seFeDataName']
            }], fixedPosition: [{
                type: Input,
                args: ['seFeDataFixedPosition']
            }], visible: [{
                type: Input
            }], visibleClass: [{
                type: HostBinding,
                args: ['class.se-fe-popover--visible']
            }], hidden: [{
                type: HostBinding,
                args: ['attr.aria-hidden']
            }], id: [{
                type: HostBinding,
                args: ['attr.id']
            }], role: [{
                type: HostBinding,
                args: ['attr.role']
            }], desc: [{
                type: HostBinding,
                args: ['attr.aria-labelledy']
            }] } });

var Keys;
(function (Keys) {
    Keys["ENTER"] = "Enter";
    Keys["SPACE"] = "Space";
})(Keys || (Keys = {}));
class SeFePopoverTriggerDirective {
    constructor(elementRef, seFePositionService) {
        this.elementRef = elementRef;
        this.seFePositionService = seFePositionService;
        this.event = 'click';
        this.id = `se-fe-popover-trigger-${Date.now()}-${SeFePopoverTriggerDirective.counter++}`;
    }
    get visible() {
        const expanded = this.popoverInstance && this.popoverInstance.visible ? 'true' : 'false';
        return this.buttonEl.setAttribute('aria-expanded', expanded);
    }
    onKeyup(event) {
        const code = event.code;
        if (code === Keys.ENTER || code === Keys.SPACE) {
            event.preventDefault();
            this.element.click();
        }
    }
    get element() {
        return this.elementRef.nativeElement;
    }
    get buttonEl() {
        return this.nestedButton || this.element;
    }
    ngOnInit() {
        this.seFePositionService.addTrigger(this);
    }
    ngAfterViewInit() {
        this.updateAccessibility();
    }
    ngOnDestroy() {
        this.seFePositionService.removeTrigger(this);
    }
    get popoverInstance() {
        return this.seFePositionService.contents.find(c => c.name === this.name);
    }
    get ariaControls() {
        return this.popoverInstance && this.popoverInstance.id ? this.popoverInstance.id : null;
    }
    get nestedButton() {
        return this.element.querySelector('button');
    }
    updateAccessibility() {
        if (!this.nestedButton) {
            this.element.setAttribute('tabinex', '0');
            this.element.setAttribute('role', 'button');
        }
        this.buttonEl.setAttribute('id', this.id);
        this.buttonEl.setAttribute('aria-controls', `${this.ariaControls}`);
    }
}
SeFePopoverTriggerDirective.counter = 1;
SeFePopoverTriggerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFePopoverTriggerDirective, deps: [{ token: i0.ElementRef }, { token: i1.SeFePositionService }], target: i0.ɵɵFactoryTarget.Directive });
SeFePopoverTriggerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: SeFePopoverTriggerDirective, selector: "[seFePopoverTrigger]", inputs: { name: ["seFePopoverTrigger", "name"] }, host: { listeners: { "keydown": "onKeyup($event)" }, properties: { "visible": "this.visible" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFePopoverTriggerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[seFePopoverTrigger]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.SeFePositionService }]; }, propDecorators: { name: [{
                type: Input,
                args: ['seFePopoverTrigger']
            }], visible: [{
                type: HostBinding
            }], onKeyup: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

class SeFePopoverModule {
}
SeFePopoverModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFePopoverModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFePopoverModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFePopoverModule, declarations: [SeFePopoverComponent, SeFePopoverTriggerDirective], imports: [CommonModule], exports: [SeFePopoverComponent, SeFePopoverTriggerDirective] });
SeFePopoverModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFePopoverModule, providers: [SeFePositionService], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFePopoverModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SeFePopoverComponent, SeFePopoverTriggerDirective],
                    exports: [SeFePopoverComponent, SeFePopoverTriggerDirective],
                    providers: [SeFePositionService],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { Keys, SeFePopoverComponent, SeFePopoverModule, SeFePopoverTriggerDirective };
